import React, { useState, useRef, useEffect } from 'react';
import AvatarDropdownMenu from './AvatarDropdownMenu';
import VerifiedBadge from '../shared/VerifiedBadge';
import { storageImage, onStorageImageError } from '../../lib/img';

const CHEVRON = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

export default function AvatarDropdown({
  user, profile, collapsed = false,
  onNavigate, onSignOut,
  shows, activeShowId, onSelectShow, onManageShows,
  canCreateShow, onCreateShow,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleDown(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    function handleKey(e) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('mousedown', handleDown);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleDown);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open]);

  if (!user) return null;

  const initials    = (profile?.full_name?.[0] || user?.email?.[0] || '?').toUpperCase();
  const displayName = profile?.full_name || user?.email?.split('@')[0] || 'Guest';
  const plan        = profile?.plan || 'Free';

  return (
    <div className="ws-profile-wrap ws-profile-wrap--top" ref={wrapRef}>
      <button
        type="button"
        className={`ws-profile${collapsed ? ' ws-profile--collapsed' : ''}`}
        onClick={() => setOpen(v => !v)}
        title={collapsed ? `${displayName} · ${plan} plan` : undefined}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="ws-profile-avatar">
          {profile?.avatar_url
            ? <img src={storageImage(profile.avatar_url, { width: 96 })} onError={(e) => onStorageImageError(e, profile.avatar_url)} alt="" />
            : <span>{initials}</span>}
        </span>
        {!collapsed && (
          <>
            <span className="ws-profile-info">
              <span className="ws-profile-name">
                {displayName}
                <VerifiedBadge verified={profile?.verified} />
              </span>
              <span className="ws-profile-plan">{plan} plan</span>
            </span>
            <span className={`ws-profile-caret${open ? ' open' : ''}`}>{CHEVRON}</span>
          </>
        )}
      </button>
      {open && (
        <AvatarDropdownMenu
          collapsed={collapsed}
          onClose={() => setOpen(false)}
          onNavigate={onNavigate}
          onSignOut={onSignOut}
          shows={shows}
          activeShowId={activeShowId}
          onSelectShow={onSelectShow}
          onManageShows={onManageShows}
          canCreateShow={canCreateShow}
          onCreateShow={onCreateShow}
        />
      )}
    </div>
  );
}
